import React from "react";
import { Label } from "../ui/label";

/**
 * Bilingual field label per the Phase-2 spec — EN + 中文 always visible together.
 * The EN/中文 toggle in the navbar does NOT swap these; only the surrounding chrome.
 */
export const BiField = ({ id, en, zh, required, error, children, hint }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="flex flex-wrap items-baseline gap-1.5 text-sm">
      <span className="text-[#0A2540] font-medium">{en}</span>
      <span className="text-slate-500 font-normal">{zh}</span>
      {required ? <span className="text-rose-500 font-semibold">*</span> : null}
    </Label>
    {children}
    {hint ? <p className="text-xs text-slate-500">{hint}</p> : null}
    {error ? (
      <p className="text-xs text-rose-600" data-testid={id ? `${id}-error` : undefined}>
        {error}
      </p>
    ) : null}
  </div>
);

export default BiField;
